// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"280":"afee8cfa","671":"597b1d4f","800":"aaa5e12c","919":"0dc695a1"}[chunkId] + ".chunk.css";
};